<template>
  <div id="body">
    <div class="tire_info">
      <div style="color: #2b3335">
        <div id="head2">
          <!-- <div class="title" style="display: flex;justify-content: center;align-items: center;" v-show="isResponse">
            <div class="title-img1" v-if="!notInStorage_code"><img alt="" class="img" :src="appLogo ? appLogo : '/static/AppIcon.png'"></div>
            <div class="title-font2">
              <div>
                欢迎使用{{AppName}}
              </div>
              <div>
                打开小程序查看车辆状态
              </div>
            </div>
          </div> -->
          <div v-if="infoObj && infoObj.description" class="font_bold description_item">
            <img src="https://tpms-cv.oss-cn-shenzhen.aliyuncs.com/web/2411/25173734/warm.png">
            <p v-for="(v,i) in infoObj.description.split(';')" :key="i">{{v}}</p>
          </div>
          <div v-if="dialogVisible && Boolean(AppletPrimitiveId)" class="main_block"> 
            <div class="plate_block">
              <div v-if="infoObj && infoObj.entName" class="ent_info">
                <img :src="infoObj.entLogo" v-if="infoObj.entLogo" :class="!infoObj.groupName ? 'mini_logo': ''"/>
                <div class="ent_info_right">
                  <p>{{infoObj.entName}}</p>
                  <p v-if="infoObj.groupName">{{infoObj.groupName}}</p>
                </div>
              </div>
              <div class="font_bold text_item">
                <span>轮胎号：</span>
                {{snCode}}
              </div>
              <div class="font_bold text_item" v-if="infoObj && infoObj.mileageAll">
                <span>轮胎里程：</span>
                {{lengthFormat(infoObj.mileageAll)}}</div>
              <template v-if="plate">
                <div class="font_bold">已绑定车辆 
                  <span v-if="infoObj && infoObj.idxName" style="margin-left: 5px">[{{infoObj.idxName}}]</span>
                </div>
                <div class="plate_text">{{plate}}</div>
              </template>
            </div>
            <wx-open-launch-weapp
              id="launch-btn"
              :username="AppletPrimitiveId"
              :path="pageUrl"
              @launch="handleLaunchFn"
              @error="handleErrorFn"
              style="width: 250px;"
            >
              <script type="text/wxtag-template">
                <style>
                  .open{
                    padding: 15px;
                    text-align: center;
                    margin-top: 100px;
                  }
                  .btn{
                    background-color: #19be6b;
                    color: white;
                    padding: 15px 30px;
                    border: none;
                    border-radius: 5px;
                    font-size: 20px;
                  }
                </style>
                <div class="open">
                  <button class="btn">打开小程序</button>
                </div>
              </script>
            </wx-open-launch-weapp>
            <!-- <a class="product_link" v-if="parentNumber" :href="'https://tapi.e5ex.com/product?p='+parentNumber"> -->
            <!-- <a class="product_link" v-if="parentNumber" :href="'https://tapi.e5ex.com/product?p='+(parentNumber.includes('R9') ? 'R90' : parentNumber)"> -->
            <a class="product_link" v-if="parentNumber && work_url" :href="work_url">
              查看{{parentNumber}}产品介绍
            </a>
          </div>
          <div v-else class="main_block">
            <wx-open-launch-weapp
              id="launch-btn"
              :username="AppletPrimitiveId"
              :path="pageUrl"
              @launch="handleLaunchFn"
              @error="handleErrorFn"
              style="width: 250px;"
            >
              <script type="text/wxtag-template">
                <style>
                  .open{
                    padding: 15px;
                    text-align: center;
                    margin-top: 100px;
                  }
                  .btn{
                    background-color: #19be6b;
                    color: white;
                    padding: 15px 30px;
                    border: none;
                    border-radius: 5px;
                    font-size: 20px;
                  }
                </style>
                <div class="open">
                  <button class="btn">打开小程序</button>
                </div>
              </script>
            </wx-open-launch-weapp>
          </div>
           <div v-if="!dialogVisible" class="code">
            <!-- <img :src="this.downUrl" alt="二维码" class="code-img"> -->
            <div style="font-size: 18px;color: rgba(0, 0, 0, 1);padding-top: 15px;">
              请使用微信打开
            </div>
          </div>
          <!-- <div v-else class="code">
            <img :src="this.downUrl" alt="二维码" class="code-img">
            <div style="font-size: 18px;color: rgba(0, 0, 0, 1);padding-top: 15px;">
              请保存二维码，在微信中识别
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getSign,imeiSn} from '../api/api';
export default {
  data() {
    return {
      infoObj: {},
      work_url: '',
      pageUrl: '',
      hrefUrl: '',
      appLogo: '',
      dialogVisible: true,
      type: 1,
      explainUrl: '',
      downUrl: 'https://cv.e5ex.cn/app/qrCode/iphone.png',
      sn: "",
      AppletPrimitiveId: "",
      notInStorage_code: "",
      AppName: "",
      snCode: "",
      plate: "",
      parentNumber: "",
      isResponse: false
    };
  },
  created() {
    this.checkViewport();
  },
  mounted(){
    this.ToMiniapp();
  },
  methods: {
    handleLaunchFn(e) {
      console.log('success', e.detail);
        // window.open("https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkzMTE4MDY5MA==#wechat_redirect");
    },
    handleErrorFn(e){
      console.log('fail', e.detail);
    },
    lengthFormat(length) { 
      return (length ? Math.round(length / 1000) : 0) + 'km';
    },
    ToMiniapp() {
      // window.location.href.split('#')[0]
      // window.location.href.split('R')[1].substr(3,window.location.href.split('/#/')[1].length)
      let url = location.href.split('/#/')[0];
      let sn = location.href.split('/#/')[1]
      const params = {
        url: url,
        sn: sn
      }
      getSign(params).then(({code, msg, data}) => {
        if (code === 0) {
          this.infoObj = data;
          this.AppletPrimitiveId = data.AppletPrimitiveId;
          this.AppName = data.AppName;
          this.pageUrl = data.page;
          this.isResponse = true;
          this.appLogo = data.logo;
          document.title = this.AppName || '轮胎信息';
          this.plate = data.plate;
          this.work_url = data.work_url;
          this.parentNumber = data.parentNumber;
          this.snCode = data.Sn;
          wx.config({
            debug: false,
            appId: "wxa897b31443ea9c96",
            signature: data.signature,
            nonceStr: data.nonceStr,
            timestamp: data.timestamp,
            jsApiList: [],
            openTagList: ["wx-open-launch-weapp"]
          });
          wx.ready(() => {
            console.log('wx ready')
          });
          wx.error(function (res) {
            console.log("error",res)
          });
          this.notInStorage_code = '';
        } else if (code == -2) {
          // 未入库的设备号
          // this.$message.error(`产品「SN：${data}」未入库，请联系技术支持`);
          this.notInStorage_code = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 查看当前配置
    checkViewport() {
      //判断设备 /R862177043673170
      let path = this.$router.currentRoute.path;
      this.sn = 'https://e5ex.com/'+window.location.href.split('/#/')[1];
      //下载APP
      if (path.substr(1, 1) === 'R' || path.substr(1, 4) === 'show') {
        this.type = 1;
      }
      //关注公众号
      else if (path.substr(1, 1) === 'A') {
        this.type = 2;
        this.sn = "";
      }
      let u = navigator.userAgent;
      let platform = navigator.platform;
      if (u.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
        this.dialogVisible = true;
      }else{
        this.dialogVisible = false;
      }
    },
    gotoType() {
      this.type = 2;
    }
  }
}
</script>
<style scoped>
.font_bold{
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.description_item img{
  width: 65px;
  height: 65px;
  margin-bottom: 10px;
}
.description_item{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.text_item{
  display: flex;
  justify-content: center;
  align-items: center;
}
.text_item span{
  display: inline-block;
  width: 5em;
  text-align: right;
}
.ent_info{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.ent_info>img{
  height: 45px;
  width: 45px;
  border-radius: 7.5px;
}
.ent_info>img.mini_logo{
  height: 25px;
  width: 25px;
}
.ent_info_right{
  margin-left: 10px;
  font-size: 16px;
  line-height: 25px;
}
.plate_block{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 50px;
}
.plate_text{
  padding: 5px 8px;
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin: 10px 0 0;
  width: auto;
  background-color: #fec922;
  text-align: center;
  border: 2px solid #000;
  border-radius: 8px;
}
.main_block{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.btn:active{
  background-color: rgba(25, 190, 107, 0.8);
}
.body1-img {
  position: absolute;
  height: 50px;
  width: 90px;
  right: 20px;
  top: 10px;
}
.product_link{
  display: block;
  width: 160px;
  padding: 10px;
  border-radius: 5px;
  color: #4d70ff;
  box-shadow: 0px -2px 10px 2px #CCCCCC;
  margin-top: 40px;
  text-align: center;
}

.body1-font {
  position: absolute;
  color: rgba(255, 255, 255, 0.87);
  font-size: 20px;
}

#font1 {
  top: 45px;
  right: 120px;
}

#font2 {
  top: 80px;
  right: 40px;
}

#body {
  height: 100%;
  width: 100%;
  position: absolute;
  background: url("../assets/back.jpg");
  background-size: 80%;
}

#body1 {
  position: fixed;
  background: rgba(0, 0, 0, 0.67);
  z-index: 1020000000000000;
  height: 100%;
  width: 100%;
}

#head {
  height: 320px;
  width: 200px;
  margin: 80px auto 40px;
}

#head2 {
  min-height: 280px;
  /* width: 250px; */
  padding: 0 20px;
  margin: 80px auto 0;
  position: relative;
}

.title {
  width: calc(100% + 2px);
  height: 40px;
  display: flex;
  align-items: center;
}

#title2 {
  width: 100%;
  height: 20px;
  margin: 15px 10px;
  font-size: 20px;
  color: #878787;
}

.title3 {
  width: 100%;
  height: 20px;
  margin: 15px 70px;
  font-size: 16px;
}

.title4 {
  width: 100%;
  height: 20px;
  margin: 15px 28px;
  font-size: 16px;
}

.img {
  height: 45px;
  width: 45px;
}

#title-img {
  float: left;
}

.title-img1 {
  float: left;
  display: flex;
  align-content: center;
}
.title-img1 > img{
  border-radius: 7.5px;
}

.title-font2 {
  font-family: Source Han Sans CN, sans-serif;
  float: left;
  font-size: 16px;
  line-height: 25px;
  margin-left: 8px;
  color: rgba(0, 0, 0, 1);
}

#title-font {
  font-family: Source Han Sans CN, sans-serif;
  float: right;
  font-weight: 1000;
  font-size: 30px;
  line-height: 40px;
}

.code {
  height: 180px;
  width: 100%;
  text-align: center;
  margin: 30px 0;
}

.code-img {
  height: 180px;
  width: 180px;
}

.button {
  height: 42px;
  width: 85%;
  margin: 0 auto auto;
  font-size: 20px;
  line-height: 40px;
  color: #808080;
}

.symbol {
  float: right;
  margin: auto 0;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/tireInfo.vue